import React, { useState, useEffect } from "react";
import { useFormik } from "formik";
import { Link, useNavigate } from "react-router-dom";
import { URL } from "../../../constants/URL";
import { promotionSchema } from "../../../validations";
import { getCurrentTimezoneDate } from "../../../util/columnsOrdering";
import { useAddPromotion, useUpdatePromotion } from "../../../queryHooks";
import CS from "../../../services/commonService";
import ApiLoader from "../../../loaders/ApiLoader";

const PromotionForm = ({ slug, edit, editChange, promotionData }) => {
	const navigate = useNavigate();
	const [promoData, setPromoData] = useState();
	const [formData, setFormData] = useState({
		title: "",
		subtitle: "",
		body: "",
	});

	const {
		mutateAsync: addPromotionAsync,
		data: addPromoApiData,
		error: addPromoApiError,
		isLoading: addPromoApiLoading,
	} = useAddPromotion();

	useEffect(() => {
		if (addPromoApiData) {
			CS.showSuccessMessage(
				`${addPromoApiData?.data?.message || addPromoApiData?.message}`
			);
			navigate(-1);
		}
	}, [addPromoApiData]);

	useEffect(() => {
		if (addPromoApiError) {
			CS.showErrorMessage(
				`${
					addPromoApiError?.response?.data?.message ||
					addPromoApiError?.data?.message ||
					addPromoApiError?.message
				}`
			);
		}
	}, [addPromoApiError]);

	const {
		mutateAsync: updatePromotionAsync,
		data: updatePromoApiData,
		error: updatePromoApiError,
		isLoading: updatePromoApiLoading,
	} = useUpdatePromotion();

	useEffect(() => {
		if (updatePromoApiData) {
			editChange();
			CS.showSuccessMessage(
				`${updatePromoApiData?.data?.message || updatePromoApiData?.message}`
			);
		}
	}, [updatePromoApiData]);

	useEffect(() => {
		if (updatePromoApiError) {
			CS.showErrorMessage(
				`${
					updatePromoApiError?.response?.data?.message ||
					updatePromoApiError?.data?.message ||
					updatePromoApiError?.message
				}`
			);
		}
	}, [updatePromoApiError]);

	const { values, errors, handleChange, handleSubmit, touched } = useFormik({
		validationSchema: promotionSchema,
		initialValues: formData,
		enableReinitialize: true,
		onSubmit: (value) => {
			let body = {
				...(value.title.trim() && { title: value.title.trim() }),
				...(value.subtitle
					? { subtitle: value.subtitle.trim() }
					: { subtitle: "" }),
				...(value.body.trim() && { body: value.body.trim() }),
			};
			if (slug) {
				updatePromotionAsync({
					id: slug,
					body,
				});
			} else {
				addPromotionAsync(body);
			}
		},
	});

	useEffect(() => {
		if (promotionData) {
			setPromoData(promotionData);
			setFormData({
				title: promotionData.title,
				subtitle: promotionData.subtitle,
				body: promotionData.body,
			});
		}
	}, [promotionData]);

	return (
		<React.Fragment>
			{(addPromoApiLoading || updatePromoApiLoading) && <ApiLoader />}
			<div className="row">
				<div className="col-md-12 card">
					<div id="accordion" className="collapse-setting">
						<div className="card mb-5">
							<div className="card-strip">
								<div className="modal-header p-0 pb-3 mb-4 w-100">
									<h5 className="modal-title">
										{slug ? "Update Promotion Details" : "Add New Promotion"}
									</h5>
								</div>
								{slug && (
									<div className="mt-2 mb-4">
										<div className="row">
											<div className="col-md-3">
												<p>
													Created At:{" "}
													<strong>
														{getCurrentTimezoneDate(promoData?.created_at)}
													</strong>
												</p>
											</div>
											<div className="col-md-3">
												<p>
													Updated At:{" "}
													<strong>
														{getCurrentTimezoneDate(promoData?.updated_at)}
													</strong>
												</p>
											</div>
										</div>
									</div>
								)}
								<div className="form-group">
									<label htmlFor="title">
										Title<sup className="text-danger">*</sup>
									</label>
									<input
										className="form-control"
										id="title"
										name="title"
										type="text"
										disabled={!edit}
										value={values.title}
										onChange={handleChange}
										placeholder="Enter title"
									/>
									<span className="text-danger error-msg">
										{errors.title && touched.title ? errors.title : null}
									</span>
								</div>
								<div className="form-group">
									<label htmlFor="subtitle">Sub Title</label>
									<input
										className="form-control"
										id="subtitle"
										name="subtitle"
										type="text"
										disabled={!edit}
										value={values.subtitle}
										onChange={handleChange}
										placeholder="Enter subtitle"
									/>
									<span className="text-danger error-msg">
										{errors.subtitle && touched.subtitle
											? errors.subtitle
											: null}
									</span>
								</div>
								<div className="form-group">
									<label htmlFor="body">
										Body<sup className="text-danger">*</sup>
									</label>
									<textarea
										className="form-control"
										id="body"
										name="body"
										type="text"
										rows={2}
										disabled={!edit}
										value={values.body}
										onChange={handleChange}
										placeholder="Enter Body..."
									/>
									<span className="text-danger error-msg">
										{errors.body && touched.body ? errors.body : null}
									</span>
								</div>
							</div>
						</div>
					</div>
					<div className="text-right">
						<button
							className="btn btn-primary glow-primary mr-4"
							onClick={() => {
								if (edit) handleSubmit();
							}}
						>
							Save
						</button>
						<Link to={URL.promotions} className="btn btn-outline-primary">
							Cancel
						</Link>
					</div>
				</div>
			</div>
		</React.Fragment>
	);
};

export default PromotionForm;
